module.exports = __webpack_public_path__ + "userfiles/yoli/img/logo.f643de76.png";